export default __webpack_public_path__ + "static/media/Diseno-sin-titulo-1-768x585.9531d92a.webp";